'use strict';
import React, { PureComponent } from 'react';
import SelectorFecha from './SelectorFecha';



class InputFecha extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={this.props.classContenedor}>
                <div className="seccionDatosGenerales__tituloSecundario">{this.props.titulo}</div>

                <div className="AsientosContables--overflowHidden">
                    <div className="AsientosContables--floatLeft">
                     <SelectorFecha
                            nombreInput={"selectorFechaNuevoAsiento"}
                            claseContainer= "ModalNuevoAsiento_ContenedorFecha ContabilizadorRecontabilizador__seccionFiltrosFechas ContabilizadorRecontabilizador--floatLeft ContabilizadorRecontabilizador__fechaDesdeMargin"
                            fecha={this.props.value}
                            funcionSeleccion={this.props.validarSelectorFecha}

                        /> 
                    </div>

                </div>
            </div>
        );
    }
}

export default InputFecha;